<template>
  <div class="t">Recognition {{ capitalize($i18n.t('shoutouts.point', { count: 2 })) }}</div>
  <div class="t-sm m-t4 gray">
    Reward with recognition {{ $i18n.t('shoutouts.point', { count: 2 }) }} for completing a Donut Intro. These {{ $i18n.t('shoutouts.point', { count: 2 }) }} can be redeemed if the {{ $i18n.t('shoutouts.rewards_store').toLowerCase() }} is enabled
  </div>
  <div class="f-as m-tx3">
    <div class="flexed">
      <donut-form-item
        v-if="showPointsToggle"
        class="short"
        :left-align="true"
        :label="`Give ${$i18n.t('shoutouts.point', { count: 2 })} for attending Donut Intros in this channel`"
      >
        <donut-input-toggle
          v-model="pointsOnCompletionEnabled"
          :paywall="paywall('disable points for this Intros channel', 'channel-enabled')"
          input-name="coffee_configuration[points_on_completion_enabled]"
        />
      </donut-form-item>
      <div v-if="!showPointsToggle" class="t-sm">Only points admins can change points settings.</div>
      <div class="f-h f-gap-8 m-tx2">
        <div class="f-h">
          <label v-emoji="pointsLabelCopy" class="p-t12" />
          <donut-form-input
            :for="pointsOnCompletion"
            name="points_on_completion"
            :validators="[integerRangeValidator(0, null, state.pointsConfig.points_name)]"
          >
            <donut-input-number
              v-model="pointsOnCompletion"
              v-tooltip="numPointsTooltip"
              :disabled="numPointsDisabled"
              input-name="coffee_configuration[points_on_completion]"
              class="w-max-100"
              :min="1"
              :step="1"
              :paywall="paywall('customize points for this Intros channel', 'num-points')"
            />
          </donut-form-input>
        </div>
      </div>
      <div
        v-emoji="exchangeRateText"
        class="m-tx2 m-lx2 t gray"
      />
    </div>
    <div class="flexed m-lx4">
      <points-slack-previews-points-for-intro-received-dm :points="pointsOnCompletion" class="w-100p" />
    </div>
  </div>
</template>

<script setup>
  import { computed, inject } from 'vue';
  import { useStore } from 'vuex';
  import { capitalize } from 'lodash';
  import useValidators from 'composables/validators';

  const $i18n = inject('$i18n');
  const { state, commit } = useStore();

  const { integerRangeValidator } = useValidators();

  const pointsOnCompletionEnabled = computed({
    get() { return state.coffeeConfiguration.points_on_completion_enabled; },
    set(value) {
      commit('updateCoffeeConfiguration', { key: 'points_on_completion_enabled', value });
      // Don't actually change the value to 0 if it was something else before, but do set the value to 1
      // if it started as 0 (page loaded with toggle off).
      if (value && state.coffeeConfiguration.points_on_completion === 0) {
        commit('updateCoffeeConfiguration', { key: 'points_on_completion', value: 1 });
      }
    },
  });
  const pointsOnCompletion = computed({
    get() {
      if (pointsOnCompletionEnabled.value) {
        return Math.max(1, state.coffeeConfiguration.points_on_completion);
      }
      return 0;
    },
    set(value) { commit('updateCoffeeConfiguration', { key: 'points_on_completion', value }); },
  });

  const pointsConfig = computed(() => state.pointsConfig.config);
  const showPointsToggle = computed(() => state.currentUser.points_admin);
  const numPointsDisabled = computed(() => !pointsOnCompletionEnabled.value || !state.currentUser.points_admin);
  const numPointsTooltip = computed(() => {
    if (pointsOnCompletionEnabled.value && !state.currentUser.points_admin) {
      return "You don't have permissions to change this.";
    }
  });
  const dollarsPerPoint = computed(() => state.pointsConfig.dollarsPerPoint);

  const exchangeRateText = computed(() => `Exchange rate 1 ${pointsConfig.value.points_name} = ${Math.round(dollarsPerPoint.value * 100)}¢ :${pointsConfig.value.emoji}:`);
  const pointsLabelCopy = computed(() => `${pointsConfig.value.points_name_plural} :${pointsConfig.value.emoji}:`);

  const paywall = (featureTitleText, sourceSuffix) => ({
    data: state.coffeeConfiguration.upgrade_data,
    feature: 'award_points_for_intros',
    featureTitleText,
    source: `intros-settings-points-${sourceSuffix}`,
    programKey: 'shoutouts',
  });
</script>
